import { EvaluationMilestoneEdit } from 'src/screens/shared/project/details/effectivity-management/evaluation-milestone/edit/EvaluationMilestoneEdit'

export const PfKapEvaluationMilestoneEditPage = () => {
  return <EvaluationMilestoneEdit baseUrl="/pf-kap" />
}
